import { DataTable } from '@/components/DataTable'
import { EmptyState } from '@/components/EmptyState'
import { Badge } from '@/components/ui/badge'
import type { ColumnDef } from '@tanstack/react-table'
import type { AuditLogRow } from '@/features/platformAdmin/types'
import { formatDateTime } from '@/lib/locale'

const fmtDate = (v: string | null) => {
  if (!v) return ''
  const d = new Date(v)
  return Number.isNaN(d.getTime()) ? v : formatDateTime(d)
}

const actorLabel = (r: AuditLogRow) =>
  r.actor_email || r.actor_name || (r.actor_type === 'system' ? 'system' : (r.actor_id ? String(r.actor_id) : '-'))

const tenantLabel = (r: AuditLogRow) =>
  r.tenant_name || (r.tenant_id ? r.tenant_id.slice(0, 8) : '-')

const actionLabel = (a: string) => a.replace(/_/g, ' ').replace(/\./g, ' › ')

export function AuditTable({ rows }: { rows: AuditLogRow[] }) {
  const columns: ColumnDef<AuditLogRow>[] = [
    {
      accessorKey: 'created_at',
      header: 'When',
      cell: ({ row }) => <span className="text-xs text-muted-foreground">{fmtDate(row.original.created_at)}</span>,
    },
    {
      id: 'actor',
      header: 'Actor',
      cell: ({ row }) => <span className="text-xs">{actorLabel(row.original)}</span>,
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: ({ row }) => (
        <Badge variant="outline" className="font-mono text-[10px]">
          {actionLabel(row.original.action)}
        </Badge>
      ),
    },
    {
      id: 'resource',
      header: 'Resource',
      cell: ({ row }) => (
        <span className="text-xs text-muted-foreground">
          {row.original.resource_type ?? '-'}
          {row.original.resource_id ? ` / ${String(row.original.resource_id).slice(0, 12)}` : ''}
        </span>
      ),
    },
    {
      id: 'tenant',
      header: 'Tenant',
      cell: ({ row }) => <span className="text-xs">{tenantLabel(row.original)}</span>,
    },
  ]
  return (
    <DataTable
      columns={columns}
      rows={rows}
      empty={<EmptyState title="No audit activity yet" />}
    />
  )
}
